import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=56a2defd&scoped=true"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=56a2defd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2defd",
  null
  
)

export default component.exports